import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ctaAttrs } from '../utils/cta';

const NewsPage = () => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const news = [
    {
      id: 8,
      date: '2026-07-30',
      category: '広報誌',
      title: '広報誌「ホームだより」第22号より — 自立援助ホームLEAPの近況',
      summary: '年1回発行の広報誌「ホームだより」第22号から、自立援助ホームLEAPのページをご紹介します。送別会・誕生会の様子や、入職1年を迎えた職員の想いを掲載しています。',
      image: '/newsletters/vol22/leap-thumb.jpg',
      pageImage: '/newsletters/vol22/leap-page.jpg',
      content: `
        当法人が年1回発行している広報誌「ホームだより」第22号から、自立援助ホームLEAPのページをご紹介します。上の誌面画像はクリックすると大きくご覧いただけます。以下は誌面の内容の文字起こしです。

        ■ 現在のLEAP
        現在リープでは12歳～19歳の5名が利用しています。学校に通っている子、週4でアルバイトをしている子など、それぞれが目標に向けて頑張っています。

        ■ 送別会・誕生会 — 送別会で焼肉！
        新年度より進学のために退所した利用者の送別会、そして誕生日を迎えた利用者のお祝いを兼ねて、5月にホーム全体で焼肉を食べに行きました。宿直の方もハーモニカでお祝いしてくれました！

        ■ 退所者とのかかわり
        退所した後も、食事をしながら近況について話したり、一緒にゲームセンターで遊んだり。ホームを出た後のつながりも大切にしています。

        ■ 入職から1年が経って…（職員　鈴木 瑛士）
        2025年4月から勤務が始まり早いものでもう1年が経過しました。私は心理学部出身ということもあり、福祉の知識はある程度持っているつもりでいました。しかし実際に現場に立ってみると、思いがけないハプニングや子どもたちの言動に戸惑うことの多い1年でした。児童相談所や病院などへ業務連絡をする中で「もう学生ではないのだな」と実感する場面も増えました。

        子どもたちの生い立ちを見るとまさに教科書の事例に載っているような子がリープには多くいます。しかし、彼らは過去に負けず前へ進んでいます。私はそのような彼らを支えていく土台のような存在になれたらと思います。皆さん1年間ありがとうございました。これからもどうぞよろしくおねがいします。

      `,
      homeName: '自立援助ホームLEAP',
      homeLink: '/homes/leap',
      isNew: true
    },
    {
      id: 9,
      date: '2026-07-29',
      category: '広報誌',
      title: '広報誌「ホームだより」第22号より — 自立援助ホームTIESの近況',
      summary: '開設2年目・定員6名満員のTIESから、利用者へのQ&Aインタビューと、2年目を迎えた職員の目標宣言をお届けします。',
      image: '/newsletters/vol22/ties-thumb.jpg',
      pageImage: '/newsletters/vol22/ties-page.jpg',
      content: `
        当法人が年1回発行している広報誌「ホームだより」第22号から、自立援助ホームTIESのページをご紹介します。上の誌面画像はクリックすると大きくご覧いただけます。以下は誌面の内容の文字起こしです。

        ■ こんにちは、TIESです
        昨年の2月に開設されてから現在定員6名満員です（19歳2名・18歳2名・17歳2名）。皆それぞれ毎日学校やバイトに行き、頑張っています！ホームにいる時はリビングに集まりゲームで大盛り上がりしています。

        ■ そんなTIESの皆にQ&Aしてみた
        【M君・18歳】
        Q. 目標はある？ — A. ひとり暮らし。バイクの免許取得（中型）、Ninja400かっこいい！貯金300万。
        Q. ホームで楽しいことは？ — A. 定期的なイベントが楽しいし、嬉しい。冬スケート行きたいな。

        【R君・19歳】
        Q. 目標はある？ — A. 200万貯まったらひとり暮らし。1年後に出来たらなぁ。

        【R君・19歳】
        Q. 目標はある？ — A. 車の免許取得（9月から行きたい）。起業したい！（現場、派遣）。いろんなことに挑戦したい。親に2〜3万円仕送りしたい。
        Q. 自分変わったなと思うことは？ — A. 自分で家事や洗濯をするようになったこと。仕事場では人に気を使えるようになったことかな。

        【H君・17歳】
        Q. 目標はある？ — A. TikTokフォロワー数1000人。
        Q. 頑張りたいことは？ — A. 早起き。早く学校に行きたい！学校楽しい。
        Q. 自分変わったなと思うことは？ — A. 落ち着きがでた。意識している。

        ■ 2年目の目標宣言！！（TIES職員2年目　城戸）
        入職して1年が経ちました。異業種からということもあり、まだまだ分からないことだらけです。1年目は子どもたちと信頼関係を築くことを目標にやってきました。2年目はマイノートを作成してひとりひとりの気づいたことや関わりを書き留め考える時間を作りたいです。それぞれの子にとってよりよい対応や声掛けの仕方を見つけていき、支援員としての幅を広げることが目標です。
        この1年楽しく働かせて頂けたのはTIES職員、他ホーム職員方々の優しいご指導、支えあってのものだと感じています。また子ども達の優しさにも感謝しながら2年目頑張ります。

      `,
      homeName: '自立援助ホームTIES',
      homeLink: '/homes/ties',
      isNew: true
    },
    {
      id: 10,
      date: '2026-07-28',
      category: '広報誌',
      title: '広報誌「ホームだより」第22号より — 自立援助ホームかんらん舎の近況',
      summary: 'たこ焼きパーティや18歳を迎えた3名の誕生日会、卒業生の振袖撮影などアフター支援の取り組みをご紹介します。',
      image: '/newsletters/vol22/kanransha-thumb.jpg',
      pageImage: '/newsletters/vol22/kanransha-page.jpg',
      content: `
        当法人が年1回発行している広報誌「ホームだより」第22号から、自立援助ホームかんらん舎のページをご紹介します。上の誌面画像はクリックすると大きくご覧いただけます。以下は誌面の内容の文字起こしです。

        ■ ご挨拶
        今年が始まって早いもので半年が過ぎました。おかげさまで、無事に新年度を迎える事が出来て安心しております。昨年度は法人として初めての実習生の受け入れを実施させていただき新しい事へと挑戦をした一年になったと実感しております。反省を生かしつつ今後も実習生の受け入れを通して、まだまだ認知度が低い自立援助ホームの理解を広げると共に、学生さん方への手助けになれればと考えています。
        職員として利用者と日々を共にしながら楽しい事も頭を悩ませる事も一緒に乗り越えながら歩んでおります。イベントの開催や退所した子へ支援を続けることができる事も皆様のご理解とご支援のお力添えがあるからだと実感する日々です。この場をお借りして感謝申し上げます。今年度もかんらん舎一同、頑張っていきますのでよろしくお願いいたします。

        ■ 日常の様子
        生命保険協会さんからのご支援でホットプレートを購入させていただきました。早速、舎内でたこ焼きパーティを実施！利用者のピック使いが上手で職員が圧倒される場面も…。たこ焼きはびっくりするほど美味しく「かんらん舎でたこ焼き屋を出せるかもね（笑）」と笑いが起きました♪
        18歳を迎える利用者の誕生日をお祝いしました！今年はたまたま18歳を迎える利用者が3名も在籍しています！各々の誕生日当日に希望の食事とケーキを準備してお祝いをしています♪これからも毎年無事に誕生日が迎えられる様にみんなで沢山お祝いしました。誕生日おめでとう☆
        バレンタインには各利用者がそれぞれお菓子作りに取り組んでいました♪

        ■ アフター対応
        アフター対応として退所した利用者と定期的に連絡をとっています。今回はかんらん舎でのアフター対応をとりまとめてもらっている自立支援担当職員へコメントを頂きました。
        （自立支援担当・大屋）法人で自立支援担当職員が配置される様になり今年度で3年目を迎えます。退所していった方々へどのように関わっていけるか、ホームを含め法人全体で日々考えながら支援を行っています。
        かんらん舎では前年度から卒業生の成人のお祝いに力を入れ、その一環として20歳を迎えた卒業生に対し、振袖撮影のボランティア団体「美華音」さんのご協力の元、振袖の着付けから撮影までを実施しました。「美華音」さんは、お金や支援がなく20歳の振袖を着る事を断念しなければならない方を無くし、20歳を素敵な思い出として残していけるようにとの思いで活動されています。撮影をした卒業生もとてもいい思い出になったと語っていました。
        またこの他にも、今年度から新しい取り組みを開始し、定期的にアウトリーチを掛けられる仕組みづくりや、法人全体での利用者に対しての社会・就労への足掛かりになる様な取り組みも実施していく予定です。いつもご支援いただいている関係者の皆様方におきましては、今までと変わらず暖かく見守って頂ければと思いますので、今後ともどうぞよろしくお願いいたします。

      `,
      homeName: '自立援助ホームかんらん舎',
      homeLink: '/homes/kanransya',
      isNew: true
    },
    {
      id: 11,
      date: '2026-07-27',
      category: '広報誌',
      title: '広報誌「ホームだより」第22号より — 自立援助ホームスイッチの近況',
      summary: '糸島でのデイキャンプや誕生日会、岩手まで卒業生を訪ねたアフターケアの様子をお届けします。',
      image: '/newsletters/vol22/switch-thumb.jpg',
      pageImage: '/newsletters/vol22/switch-page.jpg',
      content: `
        当法人が年1回発行している広報誌「ホームだより」第22号から、自立援助ホームスイッチのページをご紹介します。上の誌面画像はクリックすると大きくご覧いただけます。以下は誌面の内容の文字起こしです。

        ■ ご挨拶
        自立援助ホームスイッチです！現在、スイッチでは5名の利用者が共に生活しています。それぞれのペースで学業やアルバイトを頑張っており、日々自立に向けて成長しています。今年度もスイッチ職員一同、子ども達に負けないよう頑張っていきますのでよろしくお願いいたします！

        ■ 糸島へデイキャンプ
        5月23日に糸島へデイキャンプに行きました！子ども達も一緒に食材の買い出しや仕込みを行い、キャンプを準備する過程も楽しんでいました。
        子ども達からは「BBQ美味しかった。また、行きたい！」「自分で仕込んだおにぎり美味しかったです！」と話があった為、スイッチの年1イベントとして今後も開催して行きたいと思います。

        ■ 卒業生を訪ねて
        スイッチでは利用者がホームを出た後も積極的に関わっています！ホーム長が岩手まで卒業生に会ってきました。普段は牧場の仕事をしており、早朝から仕事を頑張っていると話していました。
        また、この日は「地元だけど、行った事が無くて行ってみたかった」と話していたわんこそばを一緒に体験してきました。100杯以上食べると木札の証明書をもらえるとのことで、彼は「煩悩の数にした」と108杯食べていました！

        ■ 誕生日会
        3月、5月、6月は利用者の誕生日でした！誕生日には、子ども達の希望した飲食店で誕生日会を行っています。外食後は、ホームに戻りケーキを囲みお祝いします。バースデーソングを歌いケーキを食べた後は、職員も一緒にテレビゲームやボードゲームをして盛り上がっていました！

      `,
      homeName: '自立援助ホームスイッチ',
      homeLink: '/homes/switch',
      isNew: true
    },
    {
      id: 12,
      date: '2026-07-26',
      category: '広報誌',
      title: '広報誌「ホームだより」第22号より — 社会的養護自立支援拠点事業所そだちの樹のご紹介',
      summary: '若者の安全基地を目指す「そだちの樹」の活動紹介 — 相談支援・居場所づくり・関係機関との連携についてお伝えします。',
      image: '/newsletters/vol22/sodachinoki-thumb.jpg',
      pageImage: '/newsletters/vol22/sodachinoki-page.jpg',
      content: `
        当法人が年1回発行している広報誌「ホームだより」第22号から、社会的養護自立支援拠点事業所「そだちの樹」のページをご紹介します。上の誌面画像はクリックすると大きくご覧いただけます。以下は誌面の内容の文字起こしです。

        ■ 若者を迎える、そっと寄り添う温かな空間
        施設や里親家庭などを経験した若者をはじめ、親や家族を頼ることができない若者にとっての安全基地となれるように。いつでも帰ってこられる木陰としてそっと寄り添い、見守りつづけます。

        ■ わたしたちの活動 〜ひらく、きく、うごく、つなぐ〜
        若者たちが安心して生活できるように、人と社会とのつながりを大切にします。

        1. 相談支援 — 来所相談だけでなく、訪問（アウトリーチ）やSNSを活用した相談体制。必要に応じて、行政や医療機関などへの同行支援も行います。
        2. 居場所 — フリースペースを開設。また、安心感を共有し、気軽に集える『ここ食堂（無料の食事会）』を定期開催予定。
        3. 関係機関との連携 — 若者が巣立っていく前からつながりを作り、社会で若者を支えていくネットワークの構築。自立に向けたミニ講座の開催も実施予定。

        ■ さまざまな相談領域
        生活／就労／金銭・契約／心理的な悩み
        ※社会福祉士、弁護士や心理士などによる専門的なサポート体制もあります。

      `,
      homeName: 'そだちの樹',
      homeLink: '/sodachinoki',
      isNew: true
    },
    {
      id: 13,
      date: '2026-07-25',
      category: '広報誌',
      title: '広報誌「ホームだより」第22号より — 自立援助ホーム結ホームの近況',
      summary: '新しく広報を担当する支援員のご挨拶、利用者2名の誕生日会、サツマイモのご寄付へのお礼をお届けします。',
      image: '/newsletters/vol22/yui-thumb.jpg',
      pageImage: '/newsletters/vol22/yui-page.jpg',
      content: `
        当法人が年1回発行している広報誌「ホームだより」第22号から、自立援助ホーム結ホームのページをご紹介します。上の誌面画像はクリックすると大きくご覧いただけます。以下は誌面の内容の文字起こしです。

        ■ ご挨拶
        こんにちは、新年度より結ホームの広報を担当させていただきます。支援員の衞藤と申します。どうぞよろしくお願いいたします。昨年結ホームに入職して以降、初めて児童福祉という分野で子ども達と関わる中で大変だと感じる場面も少なくありませんが、それ以上に子ども達から学ばせてもらうことが多く、気づきにあふれた毎日を過ごしています。
        一年経ち、支援の中で大切にしていることは、子どもたち自身の選択肢を広げてあげる事だと日々感じており、そのためには、まず「知る」という事を大切にしてほしいと考えています。様々な経験や出会いを通して、自分の世界を少しづつ広げていってもらえたら嬉しいです。
        これからも子どもたち一人ひとりに寄り添いながら、日々の様子や取り組みをお伝えしていければと思います。どうぞよろしくお願いいたします。

        ■ 子どもたちの様子
        先日、利用者2名の誕生日をお祝いしました。今回は18歳を迎え成人になった利用者と、ホームに入所して初めての誕生日を迎えた17歳の利用者の誕生日会を行いました。ケーキを囲みながら、職員や他の利用者から祝福の言葉が送られ、終始和やかな雰囲気の中で楽しい時間を過ごすことができました。18歳という節目は、成人として新たな一歩を踏み出す大切な時期です。また、ホームで初めて迎える誕生日は、新しい生活の中での大切な思い出の1つになった事と思います。
        利用者たちはそれぞれ進学や就職、自立に向けた課題と向き合いながら日々を過ごしています。思うようにいかず悩むこともありますが、一歩ずつ前に進もうと努力する姿に、私たち職員も日々力を貰っています。これからも利用者一人ひとりの思いに寄り添いながら、それぞれが自分らしい未来へ歩んでいけるよう支援を続けてまいります。

        ■ 寄付のご報告とお礼
        先日、サツマイモのご寄付をいただきました。誠にありがとうございます。いただいたサツマイモを使って、スタッフが初めてのお菓子作り（サツマイモタルトとスイートポテト）に挑戦しました。難しかったですが、美味しく出来上がり、職員と子どもに好評でとても良い経験となりました。機会があれば今度は子ども達と一緒にお菓子作りに挑戦したいと思います。
        日頃より、温かいご支援を賜り、心より感謝申し上げます。今後ともどうぞよろしくお願いいたします。

      `,
      homeName: '自立援助ホーム結ホーム',
      homeLink: '/homes/yui',
      isNew: true
    },
    {
      id: 7,
      date: '2026-06-23',
      category: 'お知らせ',
      title: '社会的養護自立支援拠点事業を福岡県から受託しました',
      summary: '社会的養護自立支援拠点事業を福岡県から受託しました。現在、専用ホームページを作成中です。',
      image: null,
      content: `
        社会的養護自立支援拠点事業を福岡県から受託しました。
        現在、専用ホームページを作成中です。

        お問い合わせ先：
        電話：092-791-1673
        受付時間：平日10:00〜17:00（土日祝はお休み）
      `,
      isNew: true
    },
    {
      id: 1,
      date: '2025-12-01',
      category: 'お知らせ',
      title: '法人公式サイトを公開しました',
      summary: '法人ドメイン「sjfk.org」を取得し、これまでホームごとに分散していた情報を統合。公式サイトとしてリニューアル公開しました。',
      image: null,
      content: `
        「特定非営利活動法人 青少年の自立を支える福岡の会」の公式サイトを公開しました。
        新たに法人ドメイン「sjfk.org」を取得し、これまでホームごとに運用していた
        Webサイトをこのドメインに集約しました。今後は法人全体の情報を一元管理し、
        各ホームの最新情報や支援内容、求人情報を統合してお届けします。

        主なポイント：
        - 法人ドメイン「sjfk.org」で統一し、信頼性と見通しを向上
        - ホーム別に分散していた情報を一本化し、最新データを一箇所で確認可能
        - ホーム紹介・求人・お問い合わせを整理し、利用者/支援者が探しやすい導線に改善

        今後も活動報告やお知らせを随時更新し、透明性のある情報発信を続けてまいります。
        引き続きご支援のほどよろしくお願いいたします。
      `,
      isNew: true
    },
    {
      id: 2,
      date: '2024-12-15',
      category: 'お知らせ',
      title: 'TIES開設準備進行中',
      summary: '2025年2月開設予定の新しい自立援助ホーム「TIES」の準備が順調に進んでいます。',
      image: '/news-ties-preparation.jpg',
      content: `
        福岡市南区に開設予定の自立援助ホーム「TIES」の準備が順調に進んでいます。
        「TIES」は「つながり」を意味し、青少年と地域、青少年同士、そして過去・現在・未来を
        つなぐ新しい形の支援を目指しています。

        現在、施設の改修工事と職員の採用・研修を並行して進めており、
        2025年2月の開設に向けて着実に準備を進めています。
        
        TIESでは最新の支援理論を取り入れつつ、一人ひとりの青少年に寄り添った
        丁寧な支援を提供していく予定です。
      `,
      isNew: true,
      hidden: true
    },
    {
      id: 3,
      date: '2024-11-20',
      category: '活動報告',
      title: '秋の職員研修を実施しました',
      summary: '全職員を対象とした研修会を開催し、支援技術の向上を図りました。',
      image: '/news-training-session.jpg',
      content: `
        11月20日に全職員を対象とした秋の研修会を実施しました。
        今回のテーマは「青少年の心理的支援とコミュニケーション技術」で、
        外部講師をお招きして専門的な研修を行いました。

        研修では、青少年期の心理的特徴や効果的なコミュニケーション方法について
        学び、実際のケースを用いたロールプレイングも実施しました。

        参加した職員からは「日々の支援に活かせる具体的な技術を学べた」
        「他の職員との情報交換も有意義だった」といった感想が寄せられました。
      `,
      isNew: false,
      hidden: true
    },
    {
      id: 4,
      date: '2024-10-05',
      title: '令和6年度上半期活動報告書を公開',
      category: '報告書',
      summary: '今年度上半期の活動実績と成果をまとめた報告書を公開いたします。',
      image: '/news-annual-report.jpg',
      content: `
        令和6年度上半期（4月〜9月）の活動報告書を公開いたします。

        主な実績：
        - 支援青少年数：延べ45名
        - 就労達成者：12名
        - 進学達成者：3名
        - 退所者（自立）：8名

        この半年間も多くの青少年が自立に向けて着実に歩みを進めています。
        皆様のご支援により、充実した支援を提供することができました。
        心より感謝申し上げます。

        詳細な報告書は当法人までお問い合わせください。
      `,
      isNew: false,
      hidden: true
    },
    {
      id: 5,
      date: '2024-09-12',
      category: 'イベント',
      title: '地域交流バーベキュー大会を開催',
      summary: '地域の皆様との交流を深めるバーベキュー大会を開催し、多くの方にご参加いただきました。',
      image: '/news-bbq-event.jpg',
      content: `
        9月12日に年次恒例の地域交流バーベキュー大会を開催しました。
        今年も多くの地域の皆様にご参加いただき、青少年たちと楽しい時間を過ごしました。

        青少年たちは準備から片付けまで積極的に参加し、
        地域の方々との自然な交流を通じて、コミュニケーション能力を
        向上させることができました。

        参加者からは「青少年たちの成長を感じることができた」
        「来年もぜひ参加したい」といった温かいお声をいただきました。

        このような地域との連携こそが、青少年の健全な成長につながると
        改めて実感した一日でした。
      `,
      isNew: false,
      hidden: true
    },
    {
      id: 6,
      date: '2024-08-01',
      category: 'お知らせ',
      title: '夏季休業のお知らせ',
      summary: '事務局の夏季休業期間についてお知らせいたします。',
      image: null,
      content: `
        平素より当法人の活動にご理解とご協力をいただき、ありがとうございます。

        事務局の夏季休業期間は以下の通りです：
        
        休業期間：2024年8月13日（火）〜 8月16日（金）
        
        なお、各自立援助ホームは通常通り運営しており、
        緊急時の対応は可能です。
        
        ご不便をおかけいたしますが、何卒ご理解のほどよろしくお願いいたします。
        8月19日（月）より通常業務を再開いたします。
      `,
      isNew: false,
      hidden: true
    }
  ];

  const annualReports = [
    {
      year: '2024年度',
      description: '2024年度事業報告書等 (PDF形式：2MB)',
      url: 'https://www.npo-homepage.go.jp/npoportal/document/119300364/hokoku/2024700/2024%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A%E6%9B%B8%E7%AD%89.pdf'
    },
    {
      year: '2023年度',
      description: '2023年度事業報告書等 (PDF形式：3MB)',
      url: 'https://www.npo-homepage.go.jp/npoportal/document/119300364/hokoku/2023700/2023%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A%E6%9B%B8%E7%AD%89.pdf'
    },
    {
      year: '2022年度',
      description: '2022年度事業報告書等 (PDF形式：565KB)',
      url: 'https://www.npo-homepage.go.jp/npoportal/document/119300364/hokoku/2022700/2022%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A%E6%9B%B8%E7%AD%89.pdf'
    },
    {
      year: '2021年度',
      description: '2021年度事業報告書等 (PDF形式：147KB)',
      url: 'https://www.npo-homepage.go.jp/npoportal/document/119300364/hokoku/2021700/2021%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A%E6%9B%B8%E7%AD%89.pdf'
    },
    {
      year: '2020年度',
      description: '2020年度事業報告書等 (PDF形式：141KB)',
      url: 'https://www.npo-homepage.go.jp/npoportal/document/119300364/hokoku/2020700/2020%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A%E6%9B%B8%E7%AD%89.pdf'
    }
  ];

  // /news?article=<id> で該当記事のモーダルを直接開く（ホーム詳細ページの広報誌一覧から遷移）
  useEffect(() => {
    const articleId = Number(searchParams.get('article'));
    if (articleId) {
      const target = news.find((item) => item.id === articleId);
      if (target) setSelectedArticle(target);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const closeArticle = () => {
    setSelectedArticle(null);
    if (searchParams.get('article')) {
      setSearchParams({}, { replace: true });
    }
  };

  const getCategoryColor = (category) => {
    const colors = {
      'お知らせ': '#3B82F6',
      '活動報告': '#10B981',
      '報告書': '#8B5CF6',
      'イベント': '#F59E0B',
      '広報誌': '#EC4899'
    };
    return colors[category] || '#6B7280';
  };

  return (
    <div className="news-page">
      {/* ページヘッダー */}
      <section className="page-header">
        <div className="container">
          <h1>活動報告・お知らせ</h1>
          <p>私たちの活動や最新情報をお伝えします</p>
        </div>
      </section>

      {/* ニュース一覧 */}
      <section className="section">
        <div className="container">
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            {/* 記事一覧 */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
              gap: '2rem',
              marginBottom: '3rem'
            }}>
              {news.filter((item) => !item.hidden).map((item) => (
                <article
                  key={item.id}
                  className="news-card"
                  style={{
                    background: 'white',
                    borderRadius: '16px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                    overflow: 'hidden',
                    border: '1px solid #f0f0f0',
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    position: 'relative'
                  }}
                  onClick={() => setSelectedArticle(item)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.1)';
                  }}
                >
                  {/* NEW バッジ */}
                  {item.isNew && (
                    <div style={{
                      position: 'absolute',
                      top: '1rem',
                      right: '1rem',
                      background: '#EF4444',
                      color: 'white',
                      padding: '0.3rem 0.8rem',
                      borderRadius: '20px',
                      fontSize: '0.7rem',
                      fontWeight: '700',
                      zIndex: 2
                    }}>
                      NEW
                    </div>
                  )}

                  {/* 画像エリア */}
                  <div style={{
                    height: '200px',
                    background: item.image ? `url(${item.image}) center/cover` : 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative'
                  }}>
                    {!item.image && (
                      <div style={{
                        fontSize: '3rem',
                        color: '#94a3b8'
                      }}>📰</div>
                    )}
                    {/* カテゴリーバッジ */}
                    <div style={{
                      position: 'absolute',
                      bottom: '1rem',
                      left: '1rem',
                      background: getCategoryColor(item.category),
                      color: 'white',
                      padding: '0.4rem 1rem',
                      borderRadius: '20px',
                      fontSize: '0.8rem',
                      fontWeight: '600'
                    }}>
                      {item.category}
                    </div>
                  </div>

                  {/* コンテンツエリア */}
                  <div style={{ padding: '1.5rem' }}>
                    <div style={{
                      fontSize: '0.85rem',
                      color: '#6B7280',
                      marginBottom: '0.8rem',
                      fontWeight: '500'
                    }}>
                      {item.date}
                    </div>
                    
                    <h3 style={{
                      fontSize: '1.2rem',
                      fontWeight: '700',
                      color: 'var(--primary-color)',
                      marginBottom: '1rem',
                      lineHeight: '1.4'
                    }}>
                      {item.title}
                    </h3>
                    
                    <p style={{
                      fontSize: '0.9rem',
                      lineHeight: '1.6',
                      color: '#555',
                      margin: '0',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}>
                      {item.summary}
                    </p>

                    {/* 読み進めるアイコン */}
                    <div style={{
                      marginTop: '1.5rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: 'var(--primary-color)',
                      fontSize: '0.9rem',
                      fontWeight: '600'
                    }}>
                      詳細を読む
                      <span style={{ fontSize: '0.7rem' }}>→</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 記事詳細モーダル */}
      {selectedArticle && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.8)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem'
        }} onClick={closeArticle}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            maxWidth: '800px',
            maxHeight: '80vh',
            overflow: 'auto',
            position: 'relative'
          }} onClick={(e) => e.stopPropagation()}>
            {/* 閉じるボタン */}
            <button
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'rgba(0,0,0,0.1)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.2rem',
                cursor: 'pointer',
                zIndex: 2
              }}
              onClick={closeArticle}
            >
              ×
            </button>

            {/* ヘッダー */}
            <div style={{
              background: 'var(--primary-color)',
              padding: '2rem',
              color: 'white'
            }}>
              <div style={{
                display: 'inline-block',
                background: 'rgba(255,255,255,0.2)',
                padding: '0.4rem 1rem',
                borderRadius: '20px',
                fontSize: '0.8rem',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                {selectedArticle.category}
              </div>
              <h2 style={{
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '0.5rem',
                lineHeight: '1.3',
                color: '#fff'
              }}>
                {selectedArticle.title}
              </h2>
              <div style={{
                fontSize: '0.9rem',
                opacity: '0.9'
              }}>
                {selectedArticle.date}
              </div>
            </div>

            {/* コンテンツ */}
            <div style={{ padding: '2rem' }}>
              {selectedArticle.pageImage && (
                <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
                  <img
                    src={selectedArticle.pageImage}
                    alt={`${selectedArticle.title} 誌面`}
                    style={{
                      maxWidth: '100%',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                      cursor: 'zoom-in'
                    }}
                    onClick={() => setLightboxImage(selectedArticle.pageImage)}
                  />
                  <div style={{
                    marginTop: '0.6rem',
                    fontSize: '0.8rem',
                    color: '#6B7280'
                  }}>
                    画像をクリックすると大きく表示されます
                  </div>
                </div>
              )}

              <div style={{
                background: '#f8f9fa',
                padding: '1.5rem',
                borderRadius: '12px',
                marginBottom: '2rem',
                borderLeft: '4px solid var(--accent-color)'
              }}>
                <p style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.7',
                  color: '#444',
                  margin: '0',
                  fontWeight: '500'
                }}>
                  {selectedArticle.summary}
                </p>
              </div>

              <div style={{
                fontSize: '1rem',
                lineHeight: '1.8',
                color: '#444'
              }}>
                {selectedArticle.content.split('\n').map((paragraph, index) => {
                  const text = paragraph.trim();
                  if (!text) return null;
                  if (text === '---') {
                    return <hr key={index} style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '2rem 0' }} />;
                  }
                  if (text.startsWith('■')) {
                    return (
                      <h3 key={index} style={{
                        fontSize: '1.1rem',
                        fontWeight: '700',
                        color: 'var(--primary-color)',
                        margin: '2rem 0 0.8rem',
                        paddingLeft: '0.8rem',
                        borderLeft: '4px solid var(--accent-color)'
                      }}>
                        {text.replace(/^■\s*/, '')}
                      </h3>
                    );
                  }
                  return <p key={index} style={{ marginBottom: '1.5rem' }}>{text}</p>;
                })}
              </div>

              {selectedArticle.homeLink && (
                <div style={{ marginTop: '2.5rem', textAlign: 'center' }}>
                  <Link
                    to={selectedArticle.homeLink}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.6rem',
                      background: 'var(--primary-color)',
                      color: 'white',
                      padding: '0.9rem 2rem',
                      borderRadius: '30px',
                      fontSize: '1rem',
                      fontWeight: '700',
                      textDecoration: 'none',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.15)'
                    }}
                  >
                    🏠 {selectedArticle.homeName}の詳細ページへ
                    <span style={{ fontSize: '0.8rem' }}>→</span>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* 誌面画像ライトボックス */}
      {lightboxImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.9)',
            zIndex: 1100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            cursor: 'zoom-out',
            overflow: 'auto'
          }}
          onClick={() => setLightboxImage(null)}
        >
          <button
            style={{
              position: 'fixed',
              top: '1rem',
              right: '1rem',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '44px',
              height: '44px',
              fontSize: '1.4rem',
              cursor: 'pointer',
              zIndex: 1101
            }}
            onClick={() => setLightboxImage(null)}
            aria-label="閉じる"
          >
            ×
          </button>
          <img
            src={lightboxImage}
            alt="広報誌 誌面拡大"
            style={{
              maxWidth: '96vw',
              maxHeight: '94vh',
              objectFit: 'contain',
              borderRadius: '4px',
              boxShadow: '0 8px 40px rgba(0,0,0,0.5)'
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* 年次報告書 */}
      <section className="section" style={{ background: 'var(--light-gray)' }}>
        <div className="container">
          <h2 className="section-title">年次報告書</h2>
          <div className="grid grid-3">
            {annualReports.map((report, index) => (
              <div className="card" key={index}>
                <h3>{report.year}</h3>
                <p>{report.description}</p>
                <a
                  className="btn btn-secondary"
                  href={report.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  {...ctaAttrs('annual_report', 'news_page')}
                >
                  PDFダウンロード
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* メディア掲載 */}
      <section className="section">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2 className="section-title">メディア掲載情報</h2>
            <div className="media-list">
              <div className="media-item">
                <div className="media-date">2022.05.24</div>
                <div className="media-content">
                  <h4>西日本新聞</h4>
                  <p>「自立援助ホームの役割と現状」特集記事にて当法人の取り組みが紹介されました。</p>
                  <a
                    href="https://www.nishinippon.co.jp/item/927988/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                    {...ctaAttrs('external_media', 'news_page')}
                    style={{ marginTop: '0.8rem' }}
                  >
                    掲載記事を読む
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewsPage;
